import { useHistory } from "react-router-dom";

import { Button2 } from "@/ui2/atoms/Button";
import { Heading2 } from "@/ui2/atoms/Heading";
import { ModalControlled2 } from "@/ui2/molecules/Modal";

type CancellationModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export function CancellationModal({ isModalOpen, setIsModalOpen }: CancellationModalProps) {
  const history = useHistory();

  return (
    <ModalControlled2 isOpen={isModalOpen} onOpenChange={setIsModalOpen}>
      <div className="tw:flex tw:flex-col tw:gap-6">
        <Heading2 size={2}>Leave without finishing?</Heading2>

        <Divider />

        <p className="tw:text-text-secondary body-md">
          Your progress will be lost if you leave now.
        </p>

        <Divider />

        <div className="tw:flex tw:justify-end tw:gap-x-3">
          <Button2
            /** TODO: investigate re-render on button click */
            onPress={() => history.push("/app/home")}
            size="md"
            variant="secondary"
          >
            Leave
          </Button2>

          <Button2 onPress={() => setIsModalOpen(false)} size="md" variant="primary">
            Continue
          </Button2>
        </div>
      </div>
    </ModalControlled2>
  );
}

function Divider() {
  return (
    <div className="tw:h-px tw:bg-stroke-quaternary tw:-translate-x-6 tw:-left-3 tw:w-[calc(100%+(--spacing(12)))]" />
  );
}
